<template>
    <div class="section-image" :class="color">
        <layout-contained :class="padding">
            <layout-media :flip="flip">
                <template v-slot:media>
                    <image-general
                        v-if="image"
                        :image="image"
                        :imageSet="imageSet"
                        :imageSizes="imageSizes"
                        :imageAlt="imageAlt"
                        :imageAspectRatio="imageAspectRatio"
                        :imageObjectFit="imageObjectFit"
                        :imageObjectPosition="imageObjectPosition"
                        :imageLoading="imageLoading"
                        :imagePriority="imagePriority"
                    ></image-general>
                </template>
                <template v-slot:text v-if="heading || content">
                    <content-heading
                        v-if="heading"
                        :heading="heading"
                        :headingColor="headingColor"
                        :headingComponent="headingComponent"
                        :marginBottom="content ? 'mb-2 sm:mb-6' : 'mb-0'"
                        :textCentered="textCentered"
                    ></content-heading>
                    <content-text
                        v-if="content"
                        :html="content"
                        :contentColor="contentColor"
                        :textCentered="textCentered"
                    ></content-text>
                    <div v-if="buttonText" class="mt-4 sm:mt-8" :class="!!textCentered ? 'text-center' : ''">
                        <button-primary
                            :buttonColor="buttonColor || undefined"
                            :buttonRoute="buttonRoute"
                            :buttonText="buttonText"
                            :buttonClick="buttonClick"
                            :buttonClickParams="buttonClickParams"
                        ></button-primary>
                    </div>
                    <slot name="custom"></slot>
                </template>
            </layout-media>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'SectionImage',
    props: {
        padding: {
            required: false,
            default: 'py-12 sm:py-20',
            type: String,
        },
        buttonColor: {
            required: false,
            type: String,
            default: null,
        },
        buttonRoute: {
            required: false,
            type: [String, Object],
            default: null,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonClick: {
            required: false,
            type: Function,
            default: () => {},
        },
        buttonClickParams: {
            required: false,
            type: [String, Object, Array],
            default: null,
        },
        color: {
            required: false,
            type: String,
            default: null,
        },
        content: {
            required: false,
            type: String,
            default: null,
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-gray-600',
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-gray-900',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        image: {
            required: false,
            type: String,
            default: null,
        },
        imageSet: {
            required: false,
            type: String,
            default: null,
        },
        imageSizes: {
            required: false,
            type: String,
            default: null,
        },
        imageAlt: {
            required: false,
            type: String,
            default: '',
        },
        imageAspectRatio: {
            required: false,
            type: String,
            default: 'aspect-video',
        },
        imageObjectFit: {
            required: false,
            type: String,
            default: undefined,
        },
        imageObjectPosition: {
            required: false,
            type: String,
            default: undefined,
        },
        imageLoading: {
            required: false,
            type: String,
            default: undefined,
        },
        imagePriority: {
            required: false,
            type: String,
            default: undefined,
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        flip: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
};
</script>
